import DeviceService from '@/api/services/device.service';
import PositionService from '@/api/services/position.service';
import IDevice from '@/models/dto/IDevice';
import IPosition from '@/models/dto/position.dto';
import IDeviceStore from '@/models/modelStore/IDeviceStore';
import DeviceViewData from '@/models/modelView/IDeviceView';
import store from '@/store/index';
import ModemStrategyFactory from '@/strategies/modem.strategy/modem.strategy.factory';
import DevicesUtils from '@/utils/device.util';
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({ dynamic: true, store, name: 'devices' })
class Devices extends VuexModule {

    //STORE
    filterDevice = ''
    devices: IDeviceStore[] = []

    //MUTATIONS
    @Mutation
    setFilterDevice(txt: string): void {
        this.filterDevice = txt
    }

    @Mutation
    setDevices(devices: IDevice[]): void {
        this.devices = devices;
    }

    @Mutation
    setPositions(positions: IPosition[]) {
        this.devices = this.devices.map(device => {
            const position = positions.find(position => device.id === position.deviceId)
            device = DevicesUtils.addPositionRaster(device, position)
            return device
        });
        console.log(this.devices)
    }

    //ACTIONS
    @Action({ commit: 'setDevices' })
    async getDevices() {
        const res = await DeviceService.getDevices()
        return res.data.sort((a: any, b: any) => (a.name.toUpperCase() > b.name.toUpperCase()) ? 1 : (a.name.toUpperCase() < b.name.toUpperCase()) ? -1 : 0)
    }

    @Action({ commit: 'setPositions' })
    async getPositions() {
        const res = await PositionService.getPositions()
        return res.data
    }

    //GETTERS
    get optionsDevices() {
        return this.devices.map(device => {
            return {
                value: device.id,
                text: device.name
            }
        })
    }

    get deviceInfo(): (DeviceViewData | undefined)[] {
        return this.devices.filter(item => item.name.toUpperCase().includes(this.filterDevice)).map(device => {
            return ModemStrategyFactory.create(device.model)?.mapDevice(device)
        })
    }

    @Action
    async getDevicebyId(deviceid: number) {
        return this.devices.find(device => device.id === deviceid)
    }

}

export default getModule(Devices);